import { Component, Input } from '@angular/core';

import * as _ from 'lodash';

import { LayoutNavItem } from '../layout.interface';

/**
 * Componente repsonsÃ¡vel por exibir o menu de navegaÃ§Ã£o na sidebar
 */
@Component({
  selector: 'uex-layout-nav',
  templateUrl: 'nav.component.html',
  host: {
    class: 'uex-layout-nav'
  }
})
export class LayoutNavComponent {
  @Input('items') items: Array<LayoutNavItem>;

  constructor() { }
}
